import { parseEther } from "ethers/lib/utils";
import { Sale } from "types";

export const reserveV2Wallet = process.env.REACT_APP_RESERVE_V2_WALLET!;

export const reservePrice = parseEther(
  process.env.REACT_APP_SALE_RESERVE_PRICE!
);

export const saleTiersRanges = process.env
  .REACT_APP_SALE_TIERS_RANGES!.split(",")
  .map((range) => range.split("-").map((r) => parseInt(r, 10)));

export const saleTiersPrices = process.env
  .REACT_APP_SALE_TIERS_PRICES!.split(",")
  .map(parseEther);

export const saleTiersRewards = process.env
  .REACT_APP_SALE_TIERS_REWARDS!.split(",")
  .map(parseEther);

export const reservedSalesCount = parseInt(
  process.env.REACT_APP_SALE_RESERVED_COUNT!,
  10
);

export const saleTiers: Sale[] = saleTiersRanges.map(
  ([minSupply, maxSupply], index) => ({
    minSupply,
    maxSupply,
    price: saleTiersPrices[index],
    honeyReward: saleTiersRewards[index],
  })
);

export const bearHolderDiscount = parseInt(
  process.env.REACT_APP_SALE_BEAR_HOLDER_DISCOUNT!,
  10
);
